import { useCallback, useContext } from "react";
import { GlobalOverlayContext } from "../context/OverlayContext.tsx";
import { ModalType } from "../lib/constants/Overlays.ts";
import { ConfirmDialogProps } from "../lib/types/Overlays.ts";

export const useConfirm = () => {
  const { openModal, closeModal } = useContext(GlobalOverlayContext);

  const confirm = useCallback(
    (props: Omit<ConfirmDialogProps, "isOpen" | "onSubmit" | "onClose">) => {
      return new Promise<string | boolean>((resolve) => {
        openModal({
          type: ModalType.CONFIRM,
          props: {
            ...props,
            isOpen: true,
            onSubmit: (comment?: string) => {
              // If a comment field was shown, resolve with the comment string
              // Otherwise resolve with true (backward-compatible with existing callers)
              resolve(props.commentLabel !== undefined ? (comment ?? "") : true);
              closeModal();
            },
            onCancel: () => {
              resolve(false);
              closeModal();
            },
          },
        });
      });
    },
    [openModal, closeModal]
  );

  return confirm;
};
